export default [
  'File name',
  'Type',
  'Created at',
  'Added/Edited',
  'Processed',
  'Error/Warnings',
  'Status',
  'Actions',
]
